import React from 'react';
import { FiGithub } from 'react-icons/fi';
import { TbSend } from 'react-icons/tb';


const Projects = ({ project }) => {

    const { name, img, description, tags, github, live } = project;


    return (
        <div>
            <div className="max-w-xs mx-auto overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
                <div className='overflow-hidden'>
                <img className="object-cover object-center w-full max-h-52 hover:scale-125 ease-in duration-500 cursor-pointer" src={img} alt="projet" />
                </div>
                    <div className="flex flex-wrap justify-center items-center bg-gray-900 h-24 sm:h-20 py-2">
                        {
                            tags.map(item => {
                                return (
                                    <>
                                        <span key={item.id} className="bg-gray-200 rounded-full px-3 text-sm font-semibold text-gray-700 mr-2">{item.tag}</span>
                                    </>
                                )
                            })
                        }
                    </div>
                <div className="px-6 py-4">
                    <h1 className="text-lg font-semibold text-gray-800 dark:text-white">{name}</h1>
                    <p className=" text-gray-700 dark:text-gray-400 text-md">{description}</p>
                </div>

                {/* Button */}
                <div className='flex justify-center items-center gap-3 pb-4'>
                    <a href='#' class="flex items-center px-2 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-200 transform bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80" >
                        <FiGithub/>
                        <a href={github} target={'_blank'} class="mx-1">Github</a>
                    </a>
                    <a href='#' class="flex items-center px-2 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-200 transform bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80" >
                        <TbSend/>
                        <a href={live} target={'_blank'} class="mx-1">Live</a>
                    </a>
                </div>
            </div>

        </div>
    );
};

export default Projects;